var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallpaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 0.25V6.5C0.25 7.03043 0.460714 7.53914 0.835786 7.91421C1.21086 8.28929 1.71957 8.5 2.25 8.5C2.78043 8.5 3.28914 8.28929 3.66421 7.91421C4.03929 7.53914 4.25 7.03043 4.25 6.5C4.25 6.10218 4.09196 5.72064 3.81066 5.43934C3.52936 5.15804 3.14782 5 2.75 5C2.41848 5 2.10054 5.1317 1.86612 5.36612C1.6317 5.60054 1.5 5.91848 1.5 6.25V6.25C1.5 6.51522 1.60536 6.76957 1.79289 6.95711C1.98043 7.14464 2.23478 7.25 2.5 7.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5H9.5C9.96372 5.00132 10.4081 5.18612 10.736 5.51402C11.0639 5.84192 11.2487 6.28628 11.25 6.75C11.2487 7.21372 11.0639 7.65808 10.736 7.98598C10.4081 8.31388 9.96372 8.49868 9.5 8.5H2.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0.75C2.5472 1.04518 2.79985 1.38204 3 1.75C3.20015 1.38204 3.4528 1.04518 3.75 0.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 3C4.5472 3.29518 4.79985 3.63204 5 4C5.20015 3.63204 5.4528 3.29518 5.75 3",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 3C0.547199 3.29518 0.799847 3.63204 1 4C1.20015 3.63204 1.4528 3.29518 1.75 3",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 0.75C6.5472 1.04518 6.79985 1.38204 7 1.75C7.20015 1.38204 7.4528 1.04518 7.75 0.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 0.75C10.5472 1.04518 10.7998 1.38204 11 1.75C11.2002 1.38204 11.4528 1.04518 11.75 0.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 3C12.5472 3.29518 12.7998 3.63204 13 4C13.2002 3.63204 13.4528 3.29518 13.75 3",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 5.25C14.5472 5.54518 14.7998 5.88204 15 6.25C15.2002 5.88204 15.4528 5.54518 15.75 5.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1016 6.04625C11.2913 5.76027 11.5086 5.49357 11.7503 5.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3C8.5472 3.29518 8.79985 3.63204 9 4C9.20015 3.63204 9.4528 3.29518 9.75 3",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7.5C12.5472 7.79518 12.7998 8.13204 13 8.5C13.2002 8.13204 13.4528 7.79518 13.75 7.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 0.75C14.5472 1.04518 14.7998 1.38204 15 1.75C15.2002 1.38204 15.4528 1.04518 15.75 0.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 12C12.5472 12.2952 12.7998 12.632 13 13C13.2002 12.632 13.4528 12.2952 13.75 12",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13C9.20015 12.632 9.4528 12.2952 9.75 12",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14.25C14.5472 14.5452 14.7998 14.882 15 15.25C15.2002 14.882 15.4528 14.5452 15.75 14.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 14.25C10.5472 14.5452 10.7998 14.882 11 15.25C11.2002 14.882 11.4528 14.5452 11.75 14.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.75C14.5472 10.0452 14.7998 10.382 15 10.75C15.2002 10.382 15.4528 10.0452 15.75 9.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 9.75C10.5472 10.0452 10.7998 10.382 11 10.75C11.2002 10.382 11.4528 10.0452 11.75 9.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.75V15.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallpaper);
export default __webpack_public_path__ + "static/media/wallpaper.b52c3927.svg";
export { ForwardRef as ReactComponent };